var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
import { canMutateHistory, isCollectionElement, isHDCA } from "@/api";
import ExpandedItems from "@/components/History/Content/ExpandedItems";
import { updateContentFields } from "@/components/History/model/queries";
import { useCollectionElementsStore } from "@/stores/collectionElementsStore";
import CollectionDetails from "./CollectionDetails.vue";
import CollectionNavigation from "./CollectionNavigation.vue";
import CollectionOperations from "./CollectionOperations.vue";
import ContentItem from "@/components/History/Content/ContentItem.vue";
import ListingLayout from "@/components/History/Layout/ListingLayout.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionPanel',
    props: {
        history: null,
        selectedCollections: null,
        showControls: { type: Boolean, default: true },
        filterable: { type: Boolean, default: false }
    },
    emits: ["view-collection", "update:selected-collections"],
    setup(__props, { emit }) {
        const props = __props;
        const collectionElementsStore = useCollectionElementsStore();
        const offset = ref(0);
        const dsc = computed(() => {
            const currentCollection = props.selectedCollections[props.selectedCollections.length - 1];
            if (currentCollection === undefined) {
                throw new Error("No collection selected");
            }
            return currentCollection;
        });
        watch(() => [dsc.value, offset.value], () => {
            collectionElementsStore.fetchMissingElements(dsc.value, offset.value);
        }, { immediate: true });
        const collectionElements = computed(() => { var _a; return (_a = collectionElementsStore.getCollectionElements(dsc.value)) !== null && _a !== void 0 ? _a : []; });
        const loading = computed(() => collectionElementsStore.isLoadingCollectionElements(dsc.value));
        const jobState = computed(() => ("job_state_summary" in dsc.value ? dsc.value.job_state_summary : undefined));
        const populatedStateMsg = computed(() => "populated_state_message" in dsc.value ? dsc.value.populated_state_message : undefined);
        const rootCollection = computed(() => {
            if (isHDCA(props.selectedCollections[0])) {
                return props.selectedCollections[0];
            }
            else {
                throw new Error("Root collection must be an HistoryDatasetCollectionAssociation");
            }
        });
        const isRoot = computed(() => dsc.value == rootCollection.value);
        const canEdit = computed(() => isRoot.value && canMutateHistory(props.history));
        function updateDsc(collection, fields) {
            updateContentFields(collection, fields).then((response) => {
                Object.keys(response).forEach((key) => {
                    collection[key] = response[key];
                });
            });
        }
        function getItemKey(item) {
            return `${item.element_type}-${item.id}`;
        }
        function onScroll(newOffset) {
            offset.value = newOffset;
        }
        function onViewDatasetCollectionElement(element) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!isCollectionElement(element)) {
                    return;
                }
                offset.value = 0;
                const collection = Object.assign(Object.assign({}, element.object), { name: element.element_identifier, hdca_id: rootCollection.value.id });
                emit("view-collection", collection);
            });
        }
        watch(() => props.history, (newHistory, oldHistory) => {
            if (newHistory.id != oldHistory.id) {
                // Send up event closing out selected collection on history change.
                emit("update:selected-collections", []);
            }
        });
        watch(jobState, () => {
            collectionElementsStore.invalidateCollectionElements(dsc.value);
            collectionElementsStore.fetchMissingElements(dsc.value, offset.value);
        }, { deep: true });
        return { __sfc: true, props, collectionElementsStore, emit, offset, dsc, collectionElements, loading, jobState, populatedStateMsg, rootCollection, isRoot, canEdit, updateDsc, getItemKey, onScroll, onViewDatasetCollectionElement, ExpandedItems, CollectionDetails, CollectionNavigation, CollectionOperations, ContentItem, ListingLayout };
    }
});
